import { Col, Row } from "antd";
import React, { useRef, useState } from "react";
import {
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./addTemplate.module.css";

import uploadTemplateImg from "../../../../assets/uploadTemplateImg.png";
import { useNavigate } from "react-router-dom";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

function Addtemplate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [image, setimage] = useState();
  const [tempName, setTempName] = useState("");

  const imageRef = useRef();

  const onSubmit = () => {
    if (!tempName || !image) {
      dispatch(
        showAlert({
          title: "Alert",
          type: "Error",
          message: "Please add all template details",
          status: 400,
        })
      );
    } else {
      dispatch(
        EventPlanningMiddleware.createTemplate({
          name: tempName,
          image: image,
        })
      )
        .then(() => {
          navigate(-1);
        })
        .catch();
    }
  };

  return (
    <Row className={styles.mainCont}>
      <Row className={styles.colContent}>
        <TextComponent text="Upload Template" textClass={styles.heading} />
        <TextComponent
          text="Upload premade templates & customize them in app"
          textClass={styles.desc}
        />
        <InputField
          placeholder={"Enter Template Name"}
          value={tempName}
          onChange={(e) => setTempName(e.target.value)}
        />
        <img
          className={styles.image}
          src={image ? URL.createObjectURL(image) : uploadTemplateImg}
          alt="Add Template"
          onClick={() => imageRef.current.click()}
        />
        <Row className={styles.btnClasss}>
          <SubmitButton title="Add Template" onClick={onSubmit} />
          <input
            type="file"
            accept="image/*"
            ref={imageRef}
            onChange={(e) => setimage(e.target.files[0])}
            style={{ display: "none" }}
          />
        </Row>
      </Row>
    </Row>
  );
}

export default Addtemplate;
